import { render, staticRenderFns } from "./FormPageBatch.vue?vue&type=template&id=a17d7458&"
import script from "./FormPageBatch.vue?vue&type=script&lang=js&"
export * from "./FormPageBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormPageBatch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports